




























import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'GPagination',
  props: {
    currentIndex: {
      type: Number as PropType<number>,
      default: 0,
    },
    listLength: {
      type: Number as PropType<number>,
      default: 0,
    },
    pagerLength: {
      type: Number as PropType<number>,
      default: 0,
    },
    maxDisplayedItemLength: {
      type: Number as PropType<number>,
      default: 0,
    },
    maxPagerLength: {
      type: Number as PropType<number>,
      default: 0,
    },
    pagerItems: {
      type: Array as PropType<number[]>,
      default: () => [],
    },
    prevPage: {
      type: Function as PropType<Function>,
      default: () => false,
    },
    changePage: {
      type: Function as PropType<Function>,
      default: () => false,
    },
    nextPage: {
      type: Function as PropType<Function>,
      default: () => false,
    },
    watchList: {
      type: Array as PropType<number[]>,
      default: () => [],
    },
  },
  watch: {
    currentIndex() {
      this.createPager();
    },
    watchList() {
      this.createPager();
    },
  },
  computed: {
    innerPagerItems: {
      get(): number[] {
        return this.pagerItems;
      },
      set(list: number[]) {
        this.$emit('getPagerItems', list);
      },
    },
  },
  methods: {
    createPager() {
      const pagerCount = Math.ceil(this.listLength / this.maxDisplayedItemLength);
      const pager = [this.currentIndex];
      let pagerFlag = true;
      for (let i = this.maxPagerLength - 1; i > 0; i--) {
        if (pagerFlag) {
          if (pager.slice(-1)[0] < pagerCount) {
            pager.push(pager.slice(-1)[0] + 1);
            pagerFlag = !pagerFlag;
          } else {
            pager.unshift(pager[0] - 1);
            pagerFlag = !pagerFlag;
          }
        } else if (!pagerFlag) {
          if (pager[0] > 1) {
            pager.unshift(pager[0] - 1);
            pagerFlag = !pagerFlag;
          } else {
            pager.push(pager.slice(-1)[0] + 1);
            pagerFlag = !pagerFlag;
          }
        }
      }
      const modifiedPagerItems = pager.filter((data) => data > 0 && data <= pagerCount);
      this.innerPagerItems = modifiedPagerItems;
    },
  },
  created() {
    this.createPager();
  },
});
